/** Expand the already-resized mask to original 8px cells, merging adjacent cells. */
export function coveredMaskGridSpans(pixels, width, height, gridSize = 8) {
  if (!Number.isSafeInteger(width) || width < 0 ||
      !Number.isSafeInteger(height) || height < 0 ||
      !Number.isSafeInteger(gridSize) || gridSize <= 0) {
    throw new RangeError('Mask dimensions must be non-negative integers and grid size must be positive');
  }
  if (!pixels || pixels.length < width * height * 4) {
    throw new RangeError('Mask pixel data is shorter than its dimensions');
  }

  const spans = [];
  for (let top = 0; top < height; top += gridSize) {
    const bottom = Math.min(top + gridSize, height);
    let spanStart = -1;
    for (let left = 0; left < width; left += gridSize) {
      const right = Math.min(left + gridSize, width);
      let covered = false;
      for (let y = top; y < bottom && !covered; y++) {
        let index = (y * width + left) * 4;
        const rowEnd = (y * width + right) * 4;
        for (; index < rowEnd; index += 4) {
          // Preserve faint red pixels. This differs from red dominance below.
          if (pixels[index] > 0 && pixels[index + 3] > 0) {
            covered = true;
            break;
          }
        }
      }
      if (covered) {
        if (spanStart < 0) spanStart = left;
      } else if (spanStart >= 0) {
        spans.push({ x: spanStart, y: top, width: left - spanStart, height: bottom - top });
        spanStart = -1;
      }
    }
    if (spanStart >= 0) {
      spans.push({ x: spanStart, y: top, width: width - spanStart, height: bottom - top });
    }
  }
  return spans;
}

/** Convert RGBA to opaque black/white in place, preserving the original rule. */
export function convertRedMaskPixels(pixels, reverseBrush) {
  for (let index = 0; index < pixels.length; index += 4) {
    const isRed = pixels[index] > pixels[index + 1] && pixels[index] > pixels[index + 2];
    const value = isRed !== Boolean(reverseBrush) ? 255 : 0;
    pixels[index] = value;
    pixels[index + 1] = value;
    pixels[index + 2] = value;
    pixels[index + 3] = 255;
  }
  return pixels;
}
